import { async } from "q";

const commonConfig = require("../../common.config");
const axios = require("axios");
// const moment = require("moment-timezone");

export default {
    getAvatarUrl: function (avatar) {
        if (avatar && avatar.startsWith("qiniu")) {
            const fileKey = avatar.substring(6, 100);
            return `${commonConfig.file_domain}/${fileKey}?imageView2/0/w/320`;
        } else {
            return require("../assets/img/default_avatar.jpg");
        }
    },
    getImageUrl: function (uuid) {
        // https://sheet.lianinstruments.com:28288/qin_file/6a00e37e-324c-4270-8c0e-8978acb78e35
        return `${commonConfig.file_domain}/${uuid}?imageView2/0/w/320`;
    },
    getReviewImageUrl: function (uuid) {
        // https://sheet.lianinstruments.com:28288/qin_file/6a00e37e-324c-4270-8c0e-8978acb78e35
        return `https://admin.lianinstruments.com:28288/qin_file/${uuid}`;
    },
    getRequestUrl: function (path) {
        return commonConfig.base_url + path;
    },
    getScreenHeightStyle: function () {
        const height =
            document.documentElement.clientHeight || document.body.clientHeight;
        return {
            height: height + "px"
        };
    },
    toAlbumList: function (_this) {
        _this.$router.push({ name: "albums" });
        _this.$store.commit("toPage", { router_name: "albums" });
    },
    toAlbumForm: function (_this, album) {
        _this.$store.commit("setCurrentAlbum", { album: album });
        _this.$router.push({ name: "album_form" });
        _this.$store.commit("toPage", {
            router_name: album ? "album_edit" : "album_new"
        });
        console.log("toAlbumForm", _this);
    },
    toAlbumDetail: function (_this, album) {
        _this.$store.commit("setCurrentAlbum", { album: album });
        _this.$router.push({ name: "album_detail" });
        _this.$store.commit("toPage", { router_name: "album_detail" });
    },
    toSheetDetail: function (_this, sheet) {
        _this.$store.commit("setCurrentSheet", { sheet: sheet });
        _this.$router.push({ name: "sheet_detail" });
        _this.$store.commit("toPage", { router_name: "sheet_detail" });
    },
    toScoreDetail: function (_this, score) {
        _this.$store.commit("setCurrentScore", { score: score });
        _this.$router.push({ name: "upload_sheet" });
        _this.$store.commit("toPage", { router_name: "upload_sheet" });
    },
    toUploadSheet: function (_this, sheet) {
        _this.$store.commit("setCurrentSheet", { sheet: sheet });
        _this.$router.push({ name: "upload_sheet" });
        _this.$store.commit("toPage", {
            router_name: sheet ? "sheet_edit" : "sheet_new"
        });
    },
    toUploadScore: function (_this, sheet) {

        _this.$store.commit("setCurrentSheet", { sheet: sheet });
        _this.$router.push({ name: "upload_sheet" });
        _this.$store.commit("toPage", { router_name: "upload_sheet" });
    },
    toAddScore: function (_this, sheet, sequence) {
        _this.$store.commit("setCurrentSheet", { sheet: sheet });
        _this.$router.push({ name: "add_score", params: { is_add_score: true, sequence: sequence } });
        // router.push({ name: 'user', params: { userId: '123' } })
        _this.$store.commit("toPage", { router_name: "add_score" });
    },
    toSheetShowPreview: function (_this, xml) {
        _this.$store.commit("setCurrentMusicXML", { currentMusicXML: xml });
        _this.$router.push({ name: "sheet_show_preview" });
        _this.$store.commit("toPage", { router_name: "sheet_show_preview" });
    },
    getDefaultLanguage: function () {
        let lang = navigator.language || navigator.userLanguage;
        lang = lang.substr(0, 2);
        if (lang == "zh") {
            return "zh";
        } else {
            return "en";
        }
    },
    authenticatedRequest: function (options, _this) {
        _this.$store.commit("setLoading", { is_loading: true });

        return axios(options).then(
            function (response) {
                if (
                    response.data &&
                    response.data.success === false &&
                    response.data.msg === "UN_AUTHENTICATED"
                ) {
                    _this.$message({
                        message: _this.$t("login.msg.UN_AUTHENTICATED")
                    });
                    _this.$router.replace({name: "login"});
                    _this.$store.commit("forgetUser");
                }
                _this.$store.commit("setLoading", { is_loading: false });
                return response;
            }.bind(this)
        );
    },
    initStoreData: function (_this) { },
    getAlbumAvailableTags: async function (album_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: this.getRequestUrl("/tags/" + album_uuid)
            },
            _this
        );

        const result = response.data;
        console.log(result);
        if (result.success) {
            console.log('tags', result.data);
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_albums_tag_failed"),
                type: "warning"
            });
            return [];
        }
    },
    addTag: async function (_this, album_uuid, tag_uuid) {
        const response = await this.authenticatedRequest(
            {
                url: this.getRequestUrl(`/album/${album_uuid}/tag/${tag_uuid}/add`)
            },
            _this
        );
        const result = response.data;
        console.log('add tag', result);
        return result;
    },
    deleteTag: async function (_this, album_uuid, tag_uuid) {
        const response = await this.authenticatedRequest(
            {
                url: this.getRequestUrl(`/album/${album_uuid}/tag/${tag_uuid}/delete`)
            },
            _this
        );
        const result = response.data;
        console.log('add tag', result);
        return result;
    },
    getAlbumsByUuid: async function (user_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                method: "get",
                url: this.getRequestUrl("/albums/" + user_uuid)
            },
            _this
        );
        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_albums_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getGroupingAlbumsByUuid: async function(user_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                method: "get",
                url: this.getRequestUrl(`/albums/${user_uuid}/grouping`)
            },
            _this
        );
        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_albums_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getSharesByUuid: async function (
        _this,
        object_uuid,
        scope,
        type,
        field_name
    ) {
        field_name = field_name || "share_target_uuid";
        const response = await this.authenticatedRequest(
            {
                method: "get",
                url: this.getRequestUrl("/share/" + object_uuid),
                params: {
                    scope: scope,
                    type: type
                }
            },
            _this
        );
        const shareUuidArray = [];
        const result = response.data;
        if (result && result.success) {
            for (const share of result.data) {
                shareUuidArray.push(share[field_name]);
            }
        }
        return shareUuidArray;
    },
    getTagsByInstance: async function (_this, instance_uuid, field_name) {
        field_name = field_name || "tag_uuid";
        const response = await this.authenticatedRequest(
            {
                method: "get",
                url: this.getRequestUrl("/tag/" + instance_uuid)
            },
            _this
        );

        const tagUuidArray = [];
        const result = response.data;
        if (result && result.success) {
            for (const tag of result.data) {
                tagUuidArray.push(tag[field_name]);
            }
        }

        return tagUuidArray;
    },
    getTeams: async function (user_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl("/teams/" + user_uuid)
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_team_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getOrganizations: async function (user_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/organizations/" + user_uuid
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_organization_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getSheetsOfAlbum: async function (album_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl("/sheet/" + album_uuid)
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_sheets_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getAllTypeScoreOfSheet: async function (sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl("/all_type_scores/" + sheet_uuid)
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_score_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getScoresOfSheet: async function (sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl("/scores/" + sheet_uuid)
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_score_failed"),
                type: "warning"
            });
            return [];
        }
    },
    getAccOfSheet: async function (sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl("/accompaniments/" + sheet_uuid)
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result.data;
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_score_failed"),
                type: "warning"
            });
            return [];
        }
    },
    deleteAlbumByUuid: async function (album_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/album/" + album_uuid + "/delete"
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result;
        } else {
            _this.$message({
                message: _this.$t("global.msg.delete_album_failed"),
                type: "warning"
            });
            return [];
        }
    },
    deleteSheetByUuid: async function (sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/sheet/" + sheet_uuid + "/delete"
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result;
        } else {
            _this.$message({
                message: _this.$t("global.msg.delete_sheet_failed"),
                type: "warning"
            });
            return [];
        }
    },
    deleteScoreByUuid: async function (score_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/score/" + score_uuid + "/delete"
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result;
        } else {
            _this.$message({
                message: _this.$t("album.sheet.text.delete_score_failed"),
                type: "warning"
            });
            return [];
        }
    },
    releaseSheet: async function (sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/sheet/" + sheet_uuid + "/release"
                )
            },
            _this
        );

        const result = response.data;

        if (result.success) {
            return result;
        } else {
            _this.$message({
                message: _this.$t(result.msg),
                type: "warning"
            });
            return null;
        }
    },
    releaseAlbum: async function (album_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/album/" + album_uuid + "/release"
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            _this.$message({
                message: _this.$t('global.msg.release_success'),
                type: "success"
            });

            return result;
        } else {
            _this.$message({
                message: _this.$t(result.msg),
                type: "warning"
            });
            return result;
        }
    },
    offlineSheet: async function (sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/sheet/" + sheet_uuid + "/offline"
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return result;
        } else {

            // offlineSheet
            _this.$message({
                message: _this.$t(result.msg),
                type: "warning"
            });
            return result;
        }
    },
    offlineAlbum: async function (album_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/album/" + album_uuid + "/offline"
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            _this.$message({
                message: _this.$t('global.msg.offline_success'),
                type: "success"
            });
            return result;
        } else {
            _this.$message({
                message: _this.$t(result.msg),
                type: "warning"
            });
            return null;
        }
    },
    moveSheet: async function (album_uuid, sheet_uuid, _this) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/album/" + album_uuid + "/sheet/" + sheet_uuid
                )
            },
            _this
        );

        const result = response.data;
        if (result.success) {
            return true;
        } else {
            _this.$message({
                message: _this.$t("sheet.msg.move_sheet_failed"),
                type: "warning"
            });
            return false;
        }
    },

    getShareScopes: function (_this) {
        const shareScopes = ["private", "public", "team", "organization"].map(
            scope => {
                return {
                    value: scope,
                    text: _this.$t(`album.share_state.${scope}`)
                };
            }
        );
        return shareScopes;
    },

    getShareScope: function (scope, _this) {
        if (scope == "公开") return "公开";

        return _this.$t(`album.share_state.${scope}`);
    },
    breadcrumbs: function (path, _this) {
        const breadcrumbs = [];
        let items = path.split("/");
        const newItems = [];
        items.forEach(item => {
            if (item != "") {
                newItems.push(item);
            }
        });

        newItems.reduce((acc, item, index, arr) => {
            let text = "";
            let disabled = false;
            if (index == arr.length - 1) {
                disabled = true;
            }
            if (item == "album_detail") {
                const currentAlbum = _this.$store.getters.currentAlbum;
                const name = _this.commonUtils.getDataWithLanguage(_this, currentAlbum, 'name');
                text = name;
            } else if (item == "sheet_detail") {
                const currentSheet = _this.$store.getters.currentSheet;
                const name = _this.commonUtils.getDataWithLanguage(_this, currentSheet, 'name');
                text = name;
            } else {
                switch (item) {
                    case "albums":
                        text = _this.$t(`albums.title`);
                        break;
                    case "album_form":
                        text = _this.$t("album_form.sub_title");
                        break;
                    case "new_album":
                        text = _this.$t("albums.table.add_album");
                        break;
                    case "album_info_edit":
                        text = _this.$t("album_form.sub_title");
                        break;
                    case "sheet_info_edit":
                        text = _this.$t(`album.sheet.info_edit`);
                        break;
                    case "sheet_edit":
                        text = _this.$t(`album.sheet.edit`);
                        break;
                    case "upload_sheet":
                        text = _this.$t(`album.upload_sheet`);
                        break;
                    case "add_score":
                        text = _this.$t(`album.add_score`);
                        break;
                    case "create_sheet":
                        text = _this.$t(`albums.table.create_sheet`);
                        break;
                    case "upload_score":
                        text = _this.$t(`album.sheet.score_edit`);
                        break;
                    case "sheet_show_preview":
                        text = _this.$t(`upload_sheet.preview`);
                        break;
                    case "sheet_review_detail":
                        text = _this.$t(`album.sheet.review_detail`);
                        break;
                    case "album_review_detail":
                        text = _this.$t(`album.review_detail`);
                        break;
                }
            }
            const href = acc + "/" + item;
            breadcrumbs.push({
                text,
                disabled,
                href
            });
            return href;
        }, "#");
        if (breadcrumbs.length == 1) {
            return [];
        }
        return breadcrumbs;
    },
    convertTimeFormat: function (timeString, needTime = false) {
        if (needTime) {

            const date = timeString.split("T")[0];
            const dateString = date.split("-").join("/");
            let time = timeString.split("T")[1];
            time = time.split(".")[0];
            return `${dateString} - ${time}`;
        } else {
            const date = timeString.split("T")[0];
            return date.split("-").join("/");
        }
    },
    readAbleTime: function() {
        return moment.utc(utc_time).tz('Asia/Shanghai').fromNow();
    },
    readMusicXML: function (file, callback) {
        var reader = new FileReader();
        reader.onload = function fileReadCompleted() {
            callback(reader.result);
        };
        reader.readAsText(file);
    },
    getMusicXMLFromUuid: async function (_this, uuid, callback) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl(
                    "/qin_file/" + uuid + "?mime_type=text/xml"
                )
            },
            _this
        );

        const result = response.data;

        if (result) {
            callback(result);
        } else {
            _this.$message({
                message: _this.$t("global.msg.get_albums_tag_failed"),
                type: "warning"
            });
            return [];
        }
    },
    // create
    getAllComposers: async function (_this, callback) {
        const response = await this.authenticatedRequest(
            {
                url: _this.commonUtils.getRequestUrl("/composers")
            },
            _this
        );

        const composers = response.data;
        callback(composers)
    },
    getLanguageList: function (_this) {
        let languageList = JSON.parse(
            JSON.stringify(commonConfig.available_language)
        );
        languageList = Object.values(languageList);
        languageList = languageList.map(lan => {
            const currentLan = _this.$i18n.locale;
            ;
            const name = _this.$t(`global.language.${lan.key}`)
            return { text: name, value: lan.key };
            // return { text: lan.name, value: lan.key };
        });
        return languageList;
    },
    getLanguageFromData: function (data) {
        let allLanguageList = JSON.parse(
            JSON.stringify(commonConfig.available_language)
        );
        allLanguageList = Object.keys(allLanguageList);
        const langList = [];
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const splices = key.split("_");
                if (splices.length > 1) {
                    const type = splices[splices.length - 1];
                    if (allLanguageList.find(lan => lan == type)) {
                        if (!langList.find(lan => lan == type)) {
                            langList.push(type);
                        }
                    }
                }
            }
        }

        if (!langList.find(lan => lan == "base")) {
            langList.unshift("base");
        }

        return langList;
    },
    getLanguageText: function (_this, lan, default_language) {

        if (lan == "base") {
            return _this.$t(`global.lan.${default_language}`);
        } else {
            return _this.$t(`global.lan.${lan}`);
        }
    },
    formatData(data) {
        let allLanguageList = JSON.parse(
            JSON.stringify(commonConfig.available_language)
        );
        allLanguageList = Object.keys(allLanguageList);
        const newData = {};
        newData['base'] = {};
        newData['base'].name = data.name;
        newData['base'].publisher = data.publisher;
        newData['base'].editor = data.editor;
        newData['base'].description = data.description;

        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const splices = key.split("_");
                if (splices.length > 1) {
                    const type = splices.pop();
                    console.log('1111111', key, type)
                    if (allLanguageList.find(lan => lan == type)) {
                        if (!newData[type]) {
                            newData[type] = {};
                        }
                        newData[type][splices.join("")] = data[key];
                    }
                } else {
                    newData[key] = data[key];
                }
            }
        }
        return newData;
    },
    getInstrument: function (_this, instrument) {
        return _this.$t("album.sheet.instrument." + instrument);
    },
    getAlbumReviews: async function (_this, albumUuid) {
        const response = await this.authenticatedRequest(
            {
                url: this.getRequestUrl(`/album/${albumUuid}/reviews`)
            },
            _this
        );
        const result = response.data;
        return result;
    },
        getAlbumReviewsResult: async function(_this, albumUuid) {

        const response = await this.authenticatedRequest(
            {
                url: this.getRequestUrl(`/albums/${albumUuid}/sheets/reviews/result`)
            },
            _this
        );
        const result = response.data;
        if (result.success) {
            return result.data;
        }
    },
    addAlbumReviews: async function (_this, text, sheetUuid) {
        const formData = new FormData();
        formData.append("text", text);

        const response = await this.authenticatedRequest(
            {
                method: 'post',
                url: this.getRequestUrl(`/sheets/${sheetUuid}/reviews`),
                data: formData
            },
            _this
        );
        const result = response.data;
        return result;
    },
    getReviews: async function (_this, sheetUuid) {
        const response = await this.authenticatedRequest(
            {
                url: this.getRequestUrl(`/sheets/${sheetUuid}/reviews`)
            },
            _this
        );
        const result = response.data;
        console.log('get reviews', result);
        return result;
    },
    addReviews: async function (_this, text, sheetUuid) {
        const formData = new FormData();
        formData.append("text", text);

        const response = await this.authenticatedRequest(
            {
                method: 'post',
                url: this.getRequestUrl(`/sheets/${sheetUuid}/reviews`),
                data: formData
            },
            _this
        );
        const result = response.data;
        return result;
    },
    getSheetStatus: function (_this, release_status, review_status) {
        console.log('get sheet status', release_status, review_status);
        if (release_status == 'online') {
            return _this.$t('album.sheet_state.online')
        } else {
            if (review_status == 'none') {
                return _this.$t('album.sheet_state.none')
            } else if (review_status == 'reviewing') {
                return _this.$t('album.sheet_state.reviewing')
            } else if (review_status == 'prepare') {
                return _this.$t('album.sheet_state.reviewing')
            } else if (review_status == 'pass') {
                return _this.$t('album.sheet_state.pass')
            }

            return _this.$t('album.sheet_state.offline')
        }



    },
    getReviewStatus: function (_this, review_status, isPublic) {
        if (review_status == 'none') {
            return _this.$t('album.sheet_state.none')
        } else if (review_status == 'reviewing') {
            return _this.$t('album.sheet_state.reviewing')
        } else if (review_status == 'prepare') {
            return _this.$t('album.sheet_state.reviewing')
        } else if (review_status == 'pass') {
            return _this.$t('album.sheet_state.pass')
        } else {
            return ''
        }

    },
    getAlbumReleaseStatus: function (_this, release_status, review_status) {
        if (release_status == 'online') {
            return _this.$t('album.sheet_state.online')
        } else {
            let status = _this.$t('album.sheet_state.offline')

            if (review_status == 'reviewing') {
                status += `(${_this.$t('album.sheet_state.reviewing')})`
            } else if (review_status == 'rejected') {
                status += `(${_this.$t('album.sheet_state.reviewfail')})`
            } else if (review_status == 'pass') {
                status += `(${_this.$t('album.sheet_state.pass')})`
            }
            return status;
        }
    },

    getReviewStatus: function(_this, review_status) {
        if (review_status == 'created') {
            return _this.$t('album.sheet_state.reviewing')
        } else if (review_status == 'reviewing') {
            return _this.$t('album.sheet_state.reviewing')
        } else if (review_status == 'prepare') {
            return _this.$t('album.sheet_state.reviewing')
        } else if (review_status == 'pass') {
            return _this.$t('album.sheet_state.pass')
        } else if (review_status == 'rejected') {
            return _this.$t('album.sheet_state.reviewfail')
        }
    },
    getDataWithLanguage: function(_this, instance, data) {
        if (!instance || !instance.data) return;

        const currentLan = _this.$i18n.locale;
        if (instance.data[`${data}_${currentLan}`] && instance.data[`${data}_${currentLan}`].length > 0) {
            return instance.data[`${data}_${currentLan}`]
        } else if (instance.data[`${data}_base`] && instance.data[`${data}_base`].length > 0) {
            return instance.data[`${data}_base`];
        } else {
            return instance.data[`${data}`];
        };
    }

};

// TODO:
/**
 * deleteAlbumByUuid
 *
 *
 */
